import React, { useState } from "react";
import { Modal, Input } from "antd";

export default function CancelPromotionModal({
  open,
  onClose,
  onConfirm,
  loading,
}) {
  const [reason, setReason] = useState("");

  const handleOk = () => {
    onConfirm(reason);
    setReason("");
  };

  const handleCancel = () => {
    setReason("");
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      onOk={handleOk}
      confirmLoading={loading}
      title="Promotion зогсоох"
      okText="Зогсоох"
      okButtonProps={{ danger: true }}
      cancelText="Болих"
    >
      <p style={{ marginBottom: 12, color: "#555" }}>
        Энэ promotion-ийг зогсоох уу? Шалтгаанаа бичнэ үү.
      </p>
      <Input.TextArea
        required
        rows={3}
        placeholder="Зогсоосон шалтгаан ..."
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />
    </Modal>
  );
}
